module.exports = __webpack_public_path__ + "static/img/toujiao1.aef9bc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toujiao1.jpg
// module id = n8ed
// module chunks = 1